import { withStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as componentActions from '../../../../redux/actions/chats'; // trocar pelo redux que criarei no chat
import { Styles } from '../../../../styles/material-styles'
import { PapiroConsole } from '../../../../utils/papiroConsole'
import ChatMessage from './message'
import './styles.css'

function ChatConversations(props) {
  const { userSession, chats, onExecScrollToBottom } = props;

  const bottomRef = useRef(null);
  // Refs pra rastrear o id do chat atual e a contagem de mensagens entre renders.
  // O useEffect abaixo só roda o scroll quando UM desses muda — evita o efeito colateral
  // de rolar a página quando o filtro de tabs muda (que altera o `chats` Redux mas
  // NÃO muda chat.id nem a contagem do chat aberto).
  const prevChatIdRef = useRef(null);
  const prevMessageCountRef = useRef(0);

  const scrollToTheBottom = () => {
    const scrollEl = bottomRef.current;
    scrollEl?.scroll({
        top: scrollEl?.scrollHeight,
        behavior: 'smooth',
      });
  };

  useEffect(() => {
    const currentChatId = chats?.chat?.id ?? null;
    const currentMessageCount = (currentChatId && chats?.chatsv2?.[currentChatId]?.itens)
      ? Object.keys(chats.chatsv2[currentChatId].itens).length
      : 0;

    const chatChanged = prevChatIdRef.current !== currentChatId;
    // `>` (não `!==`) pra não rolar quando o histórico encolhe — só quando msg nova chega.
    const messageAdded = currentMessageCount > prevMessageCountRef.current;

    if (chatChanged || messageAdded) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
      scrollToTheBottom();
    }

    prevChatIdRef.current = currentChatId;
    prevMessageCountRef.current = currentMessageCount;
  }, [chats, onExecScrollToBottom]);
  
  return (<div className="omnichannel-chat-conversations" ref={bottomRef}>
  { 
    props.chats != null && props.chats.chat && props.chats.chat.id && props.chats.chatsv2
    && props.chats.chatsv2[props.chats.chat.id]
     && Object.keys(props.chats.chatsv2[props.chats.chat.id].itens).map((keyName, i) =>  {
    // PERF: NÃO logar aqui dentro. Este map roda por TODA mensagem a cada render;
    // logar o store inteiro (props.chats.chatsv2) por mensagem em dev derrubava o
    // navegador (CPU/memória). `key` evita recriação de DOM na reconciliação.
    let message = props.chats.chatsv2[props.chats.chat.id].itens[keyName];

    return <ChatMessage
      key={keyName}
      userSession={userSession}
      message={message}
      setLoading={props.setLoading}
      reSendMessage={props.reSendMessage}/>
  })}
  </div>)
}

ChatConversations.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chats: state.chats,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ChatConversations)))